import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export interface QuickStartGuideState {
    isOpen: boolean;
    event?: Event;
}

@Injectable({
    providedIn: "root",
})
export class QuickStartGuideService {
    private quickStartStateSubject = new BehaviorSubject<QuickStartGuideState>({
        isOpen: false,
    });

    readonly quickStartState$: Observable<QuickStartGuideState> =
        this.quickStartStateSubject.asObservable();

    toggle(event?: Event): void {
        const currentState = this.quickStartStateSubject.getValue();
        this.quickStartStateSubject.next({
            isOpen: !currentState.isOpen,
            event: event,
        });
    }
}
